<template>
    <div>
        <div ref="component1" id="myChart1"></div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import { attendanceRecordStatisticsByMap } from "../../../platform/gridding/api"
export default {
    data() {
        this.isEchart = ""
        return {
            dataList: [],
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            request({
                url: "/sqyl/admin/activityPerson/info/serviceTypeCount",
                method: "POST",
                data: {},
            }).then((res) => {
                if (res.code == 200) {
                    if (res.content) {
                        this.dataList = res.content
                        this.drawLine()
                    }

                    console.log("ches", this.dataList)
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
        unique(arr) {
            return Array.from(new Set(arr))
        },
        drawLine() {
            const myChart = this.$echarts.init(
                document.getElementById("myChart1")
            )
            let xData = []
            let xArr = []
            let aData = []
            let bData = []
            let cData = []
            let part = this.dataList
            part.forEach((item) => {
                xData.push(item.dictName)
            })
            xArr = this.unique(xData)
            xArr.forEach((item) => {
                part.forEach((it) => {
                    if (item == it.dictName && it.servicePerformance == 0) {
                        aData.push(it.serviceSum)
                    } else if (
                        item == it.dictName &&
                        it.servicePerformance == 1
                    ) {
                        bData.push(it.serviceSum)
                    } else if (
                        item == it.dictName &&
                        it.servicePerformance == 2
                    ) {
                        cData.push(it.serviceSum)
                    }
                })
            })
            console.log(xArr, aData, bData, cData, "数据")
            var option
            option = {
                color: [
                    "#9932CC",
                    "#8B0000",
                    "#E9967A",
                    "#8FBC8B",
                    "#483D8B",
                    "#2F4F4F",
                    "#00CED1",
                ],
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["满意", "较好", "差"],
                    textStyle: {
                        fontSize: 12,
                        color: "#fff",
                    },
                    top:"10%",
                    smooth: true,
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: xArr,
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                series: [
                    {
                        name: "满意",
                        type: "line",
                        data: aData,
                        smooth: true,
                    },
                    {
                        name: "较好",
                        type: "line",
                        data: bData,
                        smooth: true,
                    },
                    {
                        name: "差",
                        type: "line",
                        data: cData,
                        smooth: true,
                    },
                ],
            }

            option && myChart.setOption(option)
        },
    },
    beforeDestroy() {
        if (this.isEchart) {
            this.isEchart.clear()
        }
    },
}
</script>

<style lang="less" scoped>
#myChart1 {
    width: 400px;
    height: 25vh;
}
</style>
